<form #ngF="ngForm" class="k-form-inline" [formGroup]="form" #pForm action="#" style="width: 100%;"
  (ngSubmit)="onSubmit()">
  <div class="border-0 p-3 tile-css">
    <div class="k-form-field">
      <label class="form-label col-2">ID</label>
      <div class="col-8">
        <b>
          {{idValue}}
        </b>
      </div>
    </div>

    <!-- @if(showProjects) { -->
    <div class="k-form-field">
      <label for="project_name" class="form-label col-2">Project</label>
      <div class="col">
        <kendo-dropdownlist class="ddl" [readonly]="!showProjects" #project_name id="project_name" [data]="projects" formControlName="project_id"
          textField="project_name" valueField="id" [valuePrimitive]="true" 
          (selectionChange)="projectValueChange($event)" [defaultItem]="defaultProjectItem">
        </kendo-dropdownlist>
        <div *ngIf="project_id?.invalid" class="alert alert-danger">
          <div *ngIf="project_id?.errors?.['required']">Select a project.</div>
        </div>
      </div>
    </div>

    <!-- } -->

    <div class="k-form-field">
      <label for="title" class="form-label col-2">Title</label>
      <div class="AutosizeTextArea_container">
        <kendo-textarea class="AutosizeTextArea" formControlName="title" appAutoFocus></kendo-textarea>
        <div *ngIf="title?.invalid" class="alert alert-danger">
          <div *ngIf="title?.errors?.['required']">Title is required.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label for="descript" class="form-label col-2">Description</label>
      <div>

        <casi-kendo-editor [recordId]="userStory.id!" [value]="description_value"
          (onImageUpdated)="onImageLoaded($event)" (onValueChange)="onDescriptionChange($event)"
          [tableName]="'user_story'"></casi-kendo-editor>
        <input type="text" #descript class="form-control" formControlName="description" id="description"
          [readOnly]="true" [hidden]="true">
        <div *ngIf="description?.invalid" class="alert alert-danger">
          <div *ngIf="description?.errors?.['required']">Description is required.</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="k-form-field">
        <label class="form-label col-2">Owners</label>
        <div class="col-8">
          <div class="component-container">
            <kendo-formfield showHints="always">
              <kendo-multiselect [data]="modUsers" textField="fullName" valueField="user_id"
                formControlName="owned_by_user_ids" [valuePrimitive]="true">
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                  <span class="template">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                </ng-template>
                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                  <span class="templateOwners">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                </ng-template>
              </kendo-multiselect>
            </kendo-formfield>
            <div *ngIf="owned_by_user_ids?.invalid" class="alert alert-danger">
              <div *ngIf="owned_by_user_ids?.errors?.['required']">Owner is required.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-6">
        <div class="k-form-field">
          <label class="form-label col-3">Story Type</label>
          <div class="col-9">
            <div class="component-container">
              <kendo-formfield showHints="always">
                <div class="k-form-field-wrap">
                  <kendo-dropdownlist class="ddl" #storyType formControlName="user_story_type_id" [data]="storyTypes"
                    textField="user_story_type_description" valueField="id" [value]="selectedType"
                    [valuePrimitive]="true" (selectionChange)="selectionChange($event)"
                    [defaultItem]="defaultStoryTypeItem">
                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                      @if(dataItem.iconClass) {
                      <fa-icon class="fa-solid fa-duotone {{dataItem?.iconClass}}"
                        [icon]="['fad', dataItem?.icon]"></fa-icon>
                      }
                      {{ dataItem.user_story_type_description }}
                    </ng-template>
                    <ng-template kendoDropDownListValueTemplate let-dataItem>
                      @if(dataItem) {
                      @if(dataItem.iconClass){
                      <fa-icon class="fa-solid fa-duotone {{dataItem.iconClass}}"
                        [icon]="['fad', dataItem.icon]"></fa-icon>
                      }
                      {{ dataItem.user_story_type_description }}
                      }
                    </ng-template>
                  </kendo-dropdownlist>
                </div>

              </kendo-formfield>
              <div *ngIf="user_story_type_id?.invalid" class="alert alert-danger">
                <div *ngIf="user_story_type_id?.errors?.['required']">Story type is required.</div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="k-form-field">
          <label for="status" class="form-label col-3">Status</label>
          <div class="col-5">
            <div class="component-container">
              <kendo-formfield showHints="always">
                <kendo-dropdownlist id="status" #status formControlName="user_story_status_id" [data]="storyStatuses"
                  [defaultItem]="{ text: 'Select state', value: null }" textField="user_story_status_description"
                  valueField="id" [valuePrimitive]="true" (selectionChange)="selectionStatusChange($event)">
                </kendo-dropdownlist>
              </kendo-formfield>
              <div *ngIf="user_story_status_id?.invalid" class="alert alert-danger">
                <div *ngIf="user_story_status_id?.errors?.['required']">Story status is required.</div>
              </div>
            </div>
          </div>
          <div class="offset-1 col-4">
            <casi-status-button [storyStatus]="selectedStoryStatus"
              (onChange)="onStatusButtonChange($event)"></casi-status-button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="k-form-field">
          <label class="form-label col-3">Project Labels</label>
          <div class="col-8">
            <div class="component-container">
              <kendo-formfield showHints="always">
                <div class="k-form-field-wrap">
                  <kendo-dropdownlist class="ddl" #projectLabel formControlName="project_label_id"
                    [data]="projectLabels" textField="project_label_description" valueField="id" [valuePrimitive]="true"
                    (selectionChange)="selectionEstimateChange($event)" [defaultItem]="defaultDropdownItem">
                  </kendo-dropdownlist>
                </div>

              </kendo-formfield>

            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="k-form-field">
          <label class="form-label col-3">Priority</label>
          <div class="col-8">
            <div class="component-container">
              <kendo-formfield showHints="always">
                <div class="k-form-field-wrap">
                  <kendo-dropdownlist class="ddl" #storyPriority id="storyPriority"
                    formControlName="user_story_priority_id" [data]="storyPriorities"
                    textField="user_story_priority_description" valueField="id" [valuePrimitive]="true"
                    (selectionChange)="selectionPriorityChange($event)" [defaultItem]="defaultDropdownItem">
                  </kendo-dropdownlist>
                </div>

              </kendo-formfield>
              <div *ngIf="user_story_priority_id?.invalid" class="alert alert-danger">
                <div *ngIf="user_story_priority_id?.errors?.['required']">Story priority is required.</div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="k-form-field">
          <label class="form-label col-3">Estimate</label>
          <div class="col-8">
            <div class="component-container">
              <kendo-formfield showHints="always">
                <div class="k-form-field-wrap">
                  <kendo-dropdownlist class="ddl" #estimate formControlName="user_story_estimate_id"
                    [data]="storyEstimates" textField="user_story_estimate_description" valueField="id"
                    [valuePrimitive]="true" (selectionChange)="selectionEstimateChange($event)"
                    [defaultItem]="defaultDropdownItem">
                  </kendo-dropdownlist>
                </div>

              </kendo-formfield>
              <div *ngIf="user_story_estimate_id?.invalid" class="alert alert-danger">
                <div *ngIf="user_story_estimate_id?.errors?.['required']">Story estimate is required.</div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="col-6">

        <div class="k-form-field">
          <label class="form-label col-3">Requester</label>
          <div class="col-8">
            <div class="component-container">
              <kendo-formfield showHints="always">

                <div class="k-form-field-wrap">
                  <kendo-dropdownlist class="ddl" #requester formControlName="requested_by_user_id" [data]="users"
                    textField="fullName" valueField="id" [valuePrimitive]="true"
                    (selectionChange)="selectionRequesterChange($event)" [readonly]="true">
                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                      <span class="template">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                    </ng-template>
                    <ng-template kendoDropDownListValueTemplate let-dataItem>
                      <span class="template">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                    </ng-template>
                  </kendo-dropdownlist>
                </div>

              </kendo-formfield>
              <div *ngIf="requested_by_user_id?.invalid" class="alert alert-danger">
                <div *ngIf="requested_by_user_id?.errors?.['required']">Requester is required.</div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="d-grid d-md-flex justify-content-md-end">
    <button type="button" class="btn btn-primary me-md-2" type="submit" [disabled]="form.invalid"> Save</button>
    <button type="button" class="btn btn-secondary" (click)="closeWindow()"> Cancel</button>
  </div>

</form>
